import { getAccessToken, refreshSession } from '@/entities/user';
import { env } from '@/shared/config';

/** REST 오류 응답 봉투(ApiResponse) 중 화면에 쓸 메시지. */
interface ErrorEnvelope {
  readonly error?: { readonly message?: string } | null;
}

const WITHDRAW_FAILED = '탈퇴하지 못했습니다. 잠시 후 다시 시도해 주세요.';

const send = (): Promise<Response> => {
  const token = getAccessToken();
  return fetch(`${env.VITE_API_URL}/api/users/me`, {
    method: 'DELETE',
    headers: token ? { authorization: `Bearer ${token}` } : {},
  });
};

/**
 * 회원 탈퇴 — REST `DELETE /api/users/me`(204). 서버는 이미 탈퇴한 계정의 재요청도 성공으로 본다(멱등).
 * 액세스 토큰이 만료돼 401 이면 앱 전역 재발급기로 한 번 갱신한 뒤 다시 보낸다.
 */
export const withdrawAccountRequest = async (): Promise<void> => {
  let response = await send();

  if (response.status === 401 && (await refreshSession())) {
    response = await send();
  }

  if (response.ok) return;

  const body = (await response.json().catch(() => null)) as ErrorEnvelope | null;
  throw new Error(body?.error?.message ?? WITHDRAW_FAILED);
};
